import { useEffect, useState } from 'react';
import { getIssueTypes } from 'common/services/pm-projects-filters.service';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import { useDispatch, useSelector } from 'react-redux';
import { getIssueTypesSelector } from 'state/selectors/issue-types';
import { useDebounceCallback } from '@react-hook/debounce';
import { getIssueTypesSucceed } from 'state/actions';

let cachedPromise;

const useIssueTypes = ({ enabled = true } = {}) => {
  const issueTypes = useSelector(getIssueTypesSelector);
  const dispatch = useDispatch();
  const pmSensorAuthId = usePmSensorAuthId();
  const [isLoading, setIsLoading] = useState(enabled);

  const fetchIssueTypes = useDebounceCallback(async () => {
    try {
      if (cachedPromise === null) return;

      if (!cachedPromise) {
        cachedPromise = getIssueTypes({
          sensor_authorization_id: pmSensorAuthId
        });
      }
      const res = await cachedPromise;
      dispatch(getIssueTypesSucceed(res?.items || []));
    } catch (e) {
    } finally {
      setIsLoading(false);
      cachedPromise = null;
    }
  }, 500);

  useEffect(() => {
    setIsLoading(false);
    if (enabled && issueTypes?.length === 0) {
      setIsLoading(true);
      fetchIssueTypes();
    }
  }, [issueTypes]);

  return {
    issueTypes,
    isLoading
  };
};

export default useIssueTypes;
